/*!
 * Copyright 2019 yangjunbao <yangjunbao@shimo.im>. All rights reserved.
 * @since 2019-07-09 12:08:12
 */
import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { callback, preloadMfePlugin, startFmpPrefetch, startMfeLoad } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import BrowserSDK from '@ekuaibao/sdk-bridge/sdk/browser';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import initLogger from '../../logger/initLogger';
import { initDatafluxRum } from '../dataflux-rum';
import { initFeatBit, anonymousUser, switchFeatBitUser } from '../../lib/featbit';
import { initializeI18n, setStaffDefaultLanguage } from '../i18n-initialize';
window.__PLANTFORM__ = 'DEBUGGER';
initDatafluxRum();
initLogger();
function startup() {
    app.use({
        id: '@browser',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                preloadMfePlugin();
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(BrowserSDK);
                registerHandler();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4, Promise.all([
                        initPlatformInfo(),
                        app.sdk.initialize(),
                        initFeatBit(anonymousUser()),
                        initializeI18n()
                    ])];
            case 2:
                _a.sent();
                return [4, switchFeatBitUser()];
            case 3:
                _a.sent();
                return [4, newHomeConfig({ needInitFeatBit: false, needInitI18n: false })];
            case 4:
                _a.sent();
                initRoute();
                startFmpPrefetch();
                startMfeLoad();
                setStaffDefaultLanguage();
                initializeTitle();
                registerAPI();
                setNetworkAdapter();
                return [3, 6];
            case 5:
                e_1 = _a.sent();
                console.error('init error', e_1);
                return [3, 6];
            case 6: return [2];
        }
    });
}); };
var initPromise = null;
export var appDataInitialize = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initPromise = init();
                return [4, initPromise];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!initPromise) return [3, 2];
                    return [4, initPromise];
                case 1:
                    _a.sent();
                    initPromise = null;
                    _a.label = 2;
                case 2:
                    startup();
                    return [2];
            }
        });
    });
}
